import React from 'react';
import { observable, toJS } from 'mobx';
import ModelContext from '../contexts/ModelContext.js';
import useValue from '../hooks/use-value.js';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

function ValueToModel(props) {
  var modelRef = React.useRef(observable.map());
  var model = modelRef.current;
  var value = useValue(props.name, props.defaultValue);
  React.useEffect(function () {
    var newValue = value;

    if (!newValue) {
      newValue = {};
    }

    model.replace(toJS(newValue));
  }, [value]);
  return /*#__PURE__*/React.createElement(ModelContext.Provider, {
    value: model
  }, props.children);
}

ValueToModel.defaultProps = {
  defaultValue: null
};
ValueToModel.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.any
};
var ValueToModel$1 = observer(ValueToModel);

export default ValueToModel$1;
//# sourceMappingURL=ValueToModel.js.map
